import {Property} from './Property';

const PROPERTY_ID_NAMES = ['PID', 'pid', 'REM_PID', 'Parcel_Num'];

export default class {

  static getPropertyIdFromFeature(feature) {
    if (feature) {
      for (let name of PROPERTY_ID_NAMES) {
        const id = feature.getProperty(name);
        if (id) {
          return id;
        }
      }
    }
    return null;
  }

  constructor(feature) {
    this.feature = feature;
  }

  get id() {
    return this.pid || this.maplot;
  }

  get maplot() {
    return this.feature.getProperty('maplot') || this.feature.getProperty('MAPLOT');
  }

  get pid() {
    return this.feature.getId() || this.feature.getProperty('PID') || this.feature.getProperty('pid');
  }

  async resolveProperty(city) {
    let pid = this.pid;
    if (pid) {
      return await Property.one(city, pid);
    }

    // Try to use mblu
    const mblu = this.maplot;
    let parts = mblu.split('-');
    if (parts.length < 4) {
      parts.push('');
    }
    parts = parts.map(part => part.replace(/^0+/, ''));
    const mbluCanonical = parts.join('-');
    const {results:matches} = await Property.query(city,
      {
        constraints:[['details.mblu', '==', mbluCanonical]],
        maxResults: 1
      });
    return matches.length === 0 ? null : matches[0];
  }
}
